import styled from 'styled-components'
import Sidebar from '../../../Components/Backoffice/Sidebar'
import Header from '../../../Components/Backoffice/Header'
import Footer from '../../../Components/Backoffice/Footer'

import CardPublicacoes from '../../../Components/Backoffice/CardPublicacoes'

const Wrapper = styled.main`
  background-color: #e8e9f3;
  display: grid;
  grid-template-columns: var(--sidebar-width, 7.083vw) 1fr;
  transition: grid-template-columns 0.3s ease;
  min-height: 100vh;

  @media (max-width: 992px) {
  }
`

const Content = styled.div`
  padding: 1.771vw;
`

export default function Publicacoes (props) {

  document.title = 'SPAP - Publicações'
  return (
    <Wrapper>
      <div>
        <Sidebar />
      </div>
      <Content>
        <Header />
        <CardPublicacoes />
        <Footer />
      </Content>
    </Wrapper>
  )
}
